<template>
    <div class="">
        <div class="items-center justify-center md:hidden">
            <img class="mx-auto h-16 w-auto" :src="require('@/assets/img/logos/logo.png')"
                 alt="Brandfi logo"/>
        </div>
        <div class="my-4 text-center justify-center">
            <span class="mx-auto text-xl ">Recover your password</span>
        </div> 

        <div class="bg-red-100 border-l-4 border-red-500 text-red-700 p-2"
             v-if="errors.length">
            <div v-bind:key="error" v-for="error in errors">{{ error }}</div>
        </div>
        <div class="bg-green-100 border-l-4 border-green-500 text-green-700 p-2"
             v-if="successes.length">
            <div v-bind:key="msg" v-for="msg in successes">{{ msg }}</div>
        </div>
        <div class="mt-2">
            <div class="content-start">
                <div class="">
                    <label class="block text-sm ">Login ID(Email or phone)</label>
                    <input aria-label="Email or phone number" type="text" required
                           v-model="loginId"
                           class="appearance-none rounded-md relative block w-full px-3 py-2 border
                                       border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none
                                       focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
                           placeholder="Email or phone number"/>
                </div>
            </div>

            <div class="mt-2">
                <button type="submit" v-on:click="sendResetToken"
                        class="rounded-lg px-4 md:px-5 xl:px-4 py-3 md:py-3 xl:py-3 bg-teal-500 hover:bg-teal-600 md:text-lg
                       xl:text-base text-white uppercase font-semibold leading-tight shadow-md w-full">
                    Send reset link
                </button>
            </div>
            <div class="mt-3 flex text-center">

                <router-link :to="{name:'login'}"
                             class="font-medium mx-auto text-teal-600 hover:text-teal-500 focus:outline-none focus:underline transition ease-in-out duration-150">
                    Go back to Sign in
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    import Utils from "@/services/Utils";

    export default {
        name: 'RequestToken',
        props: {
            msg: String
        },
        data() {
            return {
                loading: false,
                errors: [],
                successes: [],
                loginId: null
            }
        },
        methods: {
            sendResetToken: function () {
                this.loading = true;
                this.errors = [];
                this.successes = [];
                if (this.loginId == null || this.loginId === '')
                    this.errors.push("Email or phone number field is required.");
                if (this.errors.length > 0) {
                    this.loading = false;
                    return;
                }

                this.axios.post(process.env.VUE_APP_SERVER_URL + '/api/v1/auth/password/forgot', {
                    login_id: this.loginId,
                    reset_link: window.location.origin + '/password/reset/_TOKEN_'
                }).then((result) => {
                    this.successes.push(result.data.data);
                }).catch((error) => {
                    if (error.response != null) {
                        if (error.response.status === 422)
                            this.errors = Utils.processError(error.response.data);
                        else if (error.response.status === 401)
                            this.errors.push(error.response.data.error.message);
                    } else
                        this.errors.push("An error occurred while connecting to server")
                }).finally(() => {
                    this.loading = false;
                });
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
